module.exports = __webpack_public_path__ + "img/om.f8832d1e.svg";